import { ReferralToDiagnosticExaminationCreateOrUpdateDetails } from '@dreryk/egabinet-referral-frontend-api';

import { Choice } from '@dreryk/watermelon';

import { createReferralDiagnosesPayload } from '../../shared/common.utils';
import { ReferralToDiagnosticExaminationFormBean } from '../ReferralToDiagnosticExaminationForm/ReferralToDiagnosticExaminationForm.types';

export const mapReferralToDiagnosticExaminationFormBeanToReferralCommandDetails = (
   formData: ReferralToDiagnosticExaminationFormBean,
   electronic = false
): ReferralToDiagnosticExaminationCreateOrUpdateDetails => {
   return {
      diagnosticLaboratoryTypeCode: Choice.withUseDefaultIfNull(
         formData.healthcareFacilityLocationSpecialty?.code ?? null
      ),
      cito: formData.cito,
      icd9ProceduresCodes: formData.icd9Procedures.map(({ code }) => code),
      diagnoses: createReferralDiagnosesPayload(formData.diagnoses.value),
      examinationObjective: Choice.withUseDefaultIfNull(formData.objective),
      examinationsAlreadyPerformed: Choice.withUseDefaultIfNull(formData.examinationsAlreadyPerformed),
      electronic: electronic,
   };
};
